import { getDataPromise } from 'brock-fetch-utils';
import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: false,
            retry: 1,
        },
    },
});

export function fetchSavedSearches(uriConstants) {
    return () => getDataPromise(uriConstants.getSavedSearch);
}
export function buildGetSavedSearchesQuery(uriConstants) {
    const key = 'savedSearches';
    return {
        queryKey: key,
        queryFn: fetchSavedSearches(uriConstants),
        staleTime: Infinity,
    };
}
